import evaluate from './evaluate'

const comps = [evaluate]

export default (app) => comps.forEach(item => app.component(item.name, item))
